import { useCallback, useState } from "react";
import { useToaster } from "../common/contexts/toast";
import { fetchBomObjectData, fetchBomObjectDataByExternalId } from "../common/services";
import { getCookie } from "../utils";
import { isPluginCookie } from "../utils/cookies";

// this hook is used to fetch bom object details by object id or external id from BE
// for plugin user we are getting bom object details by external id
// for non plugin user we are getting bom object details by object id
const useBomObject = (houseId, viewId) => {
    const [isLoading, setIsLoading] = useState(false)
    const { showToaster } = useToaster()

    // this function is used to fetch bom object details by object id from BE - for saas
    const getBomObjectDetailsByObjectId = useCallback(async (objectId) => {
        try {
            const bomObjectDetailResponse = await fetchBomObjectData(houseId, viewId, objectId)
            return bomObjectDetailResponse;
        } catch (error) {
            showToaster && showToaster(error?.response?.data?.message || error?.message || "Something went wrong", false)
            throw error
        }
    }, [houseId, viewId, showToaster])

    // this function is used to fetch bom object details by external id from BE - for plugin
    const getBomObjectDetailsByExternalId = useCallback(async (externalId) => {
        try {
            const bomObjectDetailResponse = await fetchBomObjectDataByExternalId(houseId, externalId)
            return bomObjectDetailResponse;
        } catch (error) {
            showToaster && showToaster(error?.response?.data?.message || error?.message || "Something went wrong", false)
            throw error
        }
    }, [houseId, showToaster])

    const getObjectDetails = useCallback(async (itemId) => {
        let bomObjectDetails;
        try{
            const isPluginUser = getCookie(isPluginCookie)
        
            setIsLoading(true)
            if (isPluginUser) {
                if (houseId) {
                    // for plugin user we are getting bom object details by external id
                    bomObjectDetails = await getBomObjectDetailsByExternalId(itemId)
                }
            } else {
                // for non plugin user we are getting bom object details by object id
                bomObjectDetails = await getBomObjectDetailsByObjectId(itemId)
            }
        } catch(error) {
            console.log("Error fetching bomObj detail", itemId, error);
        } finally {
            setIsLoading(false)
        }
        return bomObjectDetails
    }, [getBomObjectDetailsByExternalId, getBomObjectDetailsByObjectId, houseId])

    return {
        isLoading,
        getObjectDetails,
        getBomObjectDetailsByObjectId,
        getBomObjectDetailsByExternalId
    }
}

export default useBomObject